import request from '@/http/request'

// 查询案例分类列表
export function listCategories(query) {
    return request({
      url: '/system/case/categories/list',
      method: 'get',
      params: query
    })
  }
  // 查询案例列表
export function listCases(query) {
    return request({
      url: '/system/cases/list',
      method: 'get',
      params: query
    })
  }
  
  // 查询案例详细
  export function getCases(id) {
    return request({
      url: '/system/cases/' + id,
      method: 'get'
    })
  }
  